import React from 'react'
import { isArray, isPlainObject } from 'lodash-es'
import styles from './style.module.scss'

// import { IconMaps } from '@ow/icons'

// 序列化-将编辑器的数据格式转为HTML
const serializeToHtml = (node) => {
  if (isPlainObject(node) && typeof node.text === 'string') {
    let string = node.text
    if (node.bold) {
      string = <strong>{string}</strong>
    }
    if (node.code) {
      string = <code>{string}</code>
    }
    if (node.italic) {
      string = <em>{string}</em>
    }
    if (node.underline) {
      string = <u>{string}</u>
    }
    if (node.color) {
      string = <span style={{ color: node.color }}>{string}</span>
    }
    return string
  }

  const children = node.children.map((n) => serializeToHtml(n))

  let content = ''
  switch (node.type) {
    //  无序列表
    case 'bulleted-list':
      content = (
        <ul>
          {(node.children || []).map((m) => {
            return <li>{m.children.map((item) => serializeToHtml(item))}</li>
          })}
        </ul>
      )
      break
    // 有序列表
    case 'numbered-list':
      content = (
        <ol>
          {(node.children || []).map((m) => {
            return <li>{m.children.map((item) => serializeToHtml(item))}</li>
          })}
        </ol>
      )
      break
    // 一级标题
    case 'heading-one':
      content = <h1 className={styles.h1}>{children}</h1>
      break
    // 二级标题
    case 'heading-two':
      content = <h2 className={styles.h2}>{children}</h2>
      break
    // 引用
    case 'block-quote':
      content = <blockquote className={styles.quote}>{children}</blockquote>
      break
    case 'quote':
      content = (
        <blockquote className={styles.quote}>
          <p>{children}</p>
        </blockquote>
      )
      break
    // 图片
    case 'link':
      content = <img src={node.url} alt="" />
      break
    case 'paragraph':
      if (node.align) {
        content = (
          <div style={{ textAlign: node.align, minWidth: 345 }}>{children}</div>
        )
      } else if (node.lineHeight) {
        content = (
          <p
            className={styles[`lineHeight${node.lineHeight.replace('.', '')}`]}
          >
            {children}
          </p>
        )
      } else content = <p>{children}</p>
      break
    //  缩进
    case 'indent':
      if (node.align) {
        content = (
          <div style={{ textAlign: node.align, textIndent: '1.5em' }}>
            {children}
          </div>
        )
      } else if (node.lineHeight) {
        content = (
          <div
            style={{ textIndent: '1.5em' }}
            className={styles[`lineHeight${node.lineHeight.replace('.', '')}`]}
          >
            {children}
          </div>
        )
      } else content = <div style={{ textIndent: '1.5em' }}>{children}</div>
      break
    default:
      content = children
      break
  }

  return content
}

// const IconedTextRender = function ({ stext }) {
//   const { text, color, icon } = stext
//   return (
//     <div
//       className="flex items-center gap-1"
//       style={{
//         color,
//       }}
//     >
//       <IconMaps type={icon} width={13} height={13} fill="currentColor" />
//       {text}
//     </div>
//   )
// }

// const PlainTextRender = function ({ stext }) {
//   const isDom = React.isValidElement(stext)
//   return stext.onClick ? (
//     <div
//       className="cursor-pointer w-full"
//       onClick={stext.onClick}
//       title={stext.text}
//     >
//       {isDom ? stext : stext.text}
//     </div>
//   ) : (
//     <span title={stext.text}>{isDom ? stext : stext.text}</span>
//   )
// }

// const TextRender = function ({ value, onClick }) {
//   const stext = {
//     onClick,
//   }

//   if (isString(value)) {
//     stext.text = value
//   } else if (isPlainObject(value)) {
//     Object.assign(stext, value)
//   } else {
//     stext.text = toString(value)
//   }
//   return stext.icon ? (
//     <IconedTextRender stext={stext} />
//   ) : (
//     <PlainTextRender stext={stext} />
//   )
// }

const RichText = function ({ rowData }) {
  const slateRichText =
    rowData.shortCon_slateRichText || rowData.content_slateRichText
  if (isArray(slateRichText)) {
    return (
      <div
        style={{
          display: 'initial',
        }}
      >
        {slateRichText.map((item) => serializeToHtml(item))}
      </div>
    )
  }

  return slateRichText ? (
    <div
      style={{
        display: 'initial',
      }}
    >
      {serializeToHtml(slateRichText)}
    </div>
  ) : null
}

export default RichText
